import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ZoomIn,
  ZoomOut,
  type LucideIcon,
} from 'lucide-react';

import type {
  CameraMovementFeedbackKind,
  SingleIconMovementFeedbackKind,
  WinchMovementFeedbackKind,
} from '@/components/cameraStreamWidget/cameraStreamWidgetWrapper/cameraMovementFeedback/cameraMovementFeedback.types.ts';
import { colors } from '@/utils';

/** How long each successful-movement icon flash stays visible (hook timer + CSS animation). */
export const MOVEMENT_FEEDBACK_VISIBLE_MS = 500;

/** Same default wedge icon stroke as {@link RadialControlPad}. */
export const MOVEMENT_FEEDBACK_ICON_COLOR = colors.palette.white['900'];

export const ICON_STROKE = 2.25;
export const SINGLE_ICON_SIZE = 72;
export const WINCH_ARROW_SIZE = 56;
export const WINCH_ANCHOR_SIZE = 44;

/** Pan/tilt feedback sits slightly inward so it can show beside winch on the same edge. */
export const CAMERA_MOVEMENT_FEEDBACK_EDGE_INSET = '18%';

/** Winch feedback sits closer to the widget edge, paired with inward pan/tilt on the same side. */
export const WINCH_MOVEMENT_FEEDBACK_EDGE_INSET = '2%';

export type CameraMovementFeedbackPlacement = 'top' | 'bottom' | 'left' | 'right' | 'center';

export const MOVEMENT_FEEDBACK_PLACEMENT: Record<
  CameraMovementFeedbackKind,
  CameraMovementFeedbackPlacement
> = {
  tiltUp: 'top',
  tiltDown: 'bottom',
  panLeft: 'left',
  panRight: 'right',
  zoomIn: 'center',
  zoomOut: 'center',
  winchUp: 'top',
  winchDown: 'bottom',
  winchIn: 'left',
  winchOut: 'right',
};

/** Chevron/arrows for camera; magnify for zoom (radial pad still uses +/-). */
export const SINGLE_ICON_MOVEMENT_FEEDBACK: Record<SingleIconMovementFeedbackKind, LucideIcon> = {
  tiltUp: ChevronUp,
  tiltDown: ChevronDown,
  panLeft: ChevronLeft,
  panRight: ChevronRight,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
};

/** Arrow toward the widget edge; anchor icon slightly inward. */
export const WINCH_COMBO_FLEX: Record<
  WinchMovementFeedbackKind,
  'column' | 'column-reverse' | 'row' | 'row-reverse'
> = {
  winchUp: 'column',
  winchDown: 'column-reverse',
  winchIn: 'row',
  winchOut: 'row-reverse',
};

/** Direction arrow beside lucide `Anchor` (same winch marker as device config card). */
export const WINCH_DIRECTION_ICONS: Record<WinchMovementFeedbackKind, LucideIcon> = {
  winchUp: ArrowUp,
  winchDown: ArrowDown,
  winchIn: ArrowLeft,
  winchOut: ArrowRight,
};
